import { render, staticRenderFns } from "./shop-tags.app.vue?vue&type=template&id=451a010e&"
import script from "./shop-tags.app.vue?vue&type=script&lang=js&"
export * from "./shop-tags.app.vue?vue&type=script&lang=js&"
import style0 from "./shop-tags.app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports